import React from 'react';
import { PlusIcon, PlusCircleIcon, PencilIcon, TrashIcon, RefreshCwIcon } from 'lucide-react';
interface COAToolbarProps {
  onAddRoot: () => void;
  onAddChild: () => void;
  onEdit: () => void;
  onDelete?: () => void;
  onRecalculatePaths: () => void;
  canAddChild: boolean;
  canEdit: boolean;
  canDelete: boolean;
}
export function COAToolbar({
  onAddRoot,
  onAddChild,
  onEdit,
  onDelete,
  onRecalculatePaths,
  canAddChild,
  canEdit,
  canDelete
}: COAToolbarProps) {
  return <div className="mb-4 flex flex-wrap space-x-2" data-id="element-6968">
      <button type="button" onClick={onAddRoot} className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-6969">
        <PlusIcon className="h-4 w-4 mr-1" data-id="element-6970" />
        Add Root Segment
      </button>
      <button type="button" onClick={onAddChild} disabled={!canAddChild} className={`inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm ${canAddChild ? 'text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500' : 'text-gray-400 bg-gray-200 cursor-not-allowed'}`} data-id="element-6971">
        <PlusCircleIcon className="h-4 w-4 mr-1" data-id="element-6972" />
        Add Child Segment
      </button>
      <button type="button" onClick={onEdit} disabled={!canEdit} className={`inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm ${canEdit ? 'text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500' : 'text-gray-400 bg-gray-200 cursor-not-allowed'}`} data-id="element-6973">
        <PencilIcon className="h-4 w-4 mr-1" data-id="element-6974" />
        Edit Segment
      </button>
      {onDelete && <button type="button" onClick={onDelete} disabled={!canDelete} className={`inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm ${canDelete ? 'text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500' : 'text-gray-400 bg-gray-200 cursor-not-allowed'}`} data-id="element-6975">
          <TrashIcon className="h-4 w-4 mr-1" data-id="element-6976" />
          Delete Segment
        </button>}
      <button type="button" onClick={onRecalculatePaths} className="inline-flex items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-6977">
        <RefreshCwIcon className="h-4 w-4 mr-1" data-id="element-6978" />
        Recalculate All Paths
      </button>
    </div>;
}